module.exports = __webpack_public_path__ + "img/133.4.ec55aa52.png";